<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>订单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">订单时间段</label>
                    <el-date-picker
                        v-model="query.timeRange"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        :picker-options="pickerOptions1"
                        class="mr10"
                        :default-time="['00:00:00','23:59:59']">
                    </el-date-picker>
                </span>
              <span class="label-span">
                    <label class="label">订单状态</label>
                    <el-select v-model="query.status2" multiple placeholder="订单状态,可多选" style='width:400px' filterable class="handle-select mr10"  clearable >
                        <el-option value="" label="全部"  />
                        <el-option value="8" label="系统拦截"  />
                        <el-option value="0" label="校验失败"  />
                        <el-option value="1" label="校验成功"  />
                        <el-option value="2" label="短信失败"  />
                        <el-option value="3" label="短信成功"  />
                        <el-option value="4" label="回填失败"  />
                        <el-option value="5" label="回填成功"  />
                        <el-option value="-1" label="订购失败"  />
                        <el-option value="-2" label="用户退订"  />
                        <el-option value="9" label="订购成功"  />
                    </el-select>
                </span>  
                 <span class="label-span">
                        <label class="label">系统单号</label> 
                        <el-input v-model.trim="query.orderNo" placeholder="系统单号"  class="handle-input mr10"></el-input> 
                    </span>
                <span class="label-span">
                    <label class="label">用户号码</label> 
                    <el-input v-model.trim="query.phone" placeholder="请输入用户号码" class="handle-input mr10"></el-input> 
                </span>    
                
                <span class="label-span">
                    <label class="label">产品名称</label> 
                    <el-input v-model.trim="query.goodsName" placeholder="系统产品名称"  class="handle-input mr10"></el-input> 
                </span>  
                <span class="label-span">
                    <label class="label">产品编码</label>
                    <el-input v-model.trim="query.goodsCode" placeholder="系统产品编码" class="handle-input mr10"></el-input>
                </span>
                <span class="label-span">
                        <label class="label">订单状态描述</label>
                        <el-input v-model.trim="query.message" placeholder="订单状态描述" class="handle-input mr10"></el-input>
                    </span>
                <span class="label-span">
                        <label class="label">上游单号</label>
                        <el-input v-model.trim="query.orderTno" placeholder="请输入上游单号"  class="handle-input mr10"></el-input>
                    </span> 
                    
                    <!--<span class="label-span">
                        <label class="label">资源分类</label> 
                        <el-select v-model="query.ctype"  placeholder="资源分类" @change="changeSelect" filterable  clearable  class="handle-select mr10">
                            <el-option value="" label="全部"  />  
                            <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                        </el-select>
                    </span>
                    
                    <span class="label-span">
                        <label class="label">上游产品编码</label> 
                        <el-input v-model.trim="query.channelGoodsCode" placeholder="上游产品编码" class="handle-input mr10"></el-input> 
                    </span> --> 

                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>  
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" height="600px" border class="table"  ref="multipleTable" header-cell-class-name="table-header"
             v-loading="loading"  element-loading-text="" element-loading-spinner="el-icon-loading"  @selection-change="handleSelectionChange"  >
           
                     
                <el-table-column prop="goodsName" min-width="180" align="left" label="订单信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;"> 
                              系统单号:<el-tooltip :content="scope.row.orderNo" placement="top">
                            <el-link v-if="scope.row.orderNo" type="primary" style="font-size:10px;" @click="copyLink(scope.row.orderNo,'系统单号')">{{scope.row.orderNo}}</el-link> <br>
                        </el-tooltip> <br>
                        用户号码：<el-link type="primary" @click="copyLink(scope.row.phone,'用户号码')" style="font-size:12px;">{{scope.row.phone}}</el-link> <br>
                        用户短验：<el-link type="primary" @click="copyLink(scope.row.sms,'用户短验')" style="font-size:12px;">{{scope.row.sms}}</el-link> 
                       </p>
                    </template>
                </el-table-column>      
                <el-table-column prop="goodsName" min-width="200" align="left" label="产品信息">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">
                        产品编码：<el-link type="primary" style="font-size:12px;" @click="copyLink(scope.row.goodsCode,'产品编码')">{{scope.row.goodsCode}}</el-link> <br>
                        产品名称：<el-link type="primary" style="font-size:12px;display:inline;line-height:18px;"  @click="copyLink(scope.row.goodsName,'产品名称')">{{scope.row.goodsName}}</el-link> 
                           
                        </p>
                    </template>
                </el-table-column>     
                <el-table-column prop="goodsName" min-width="150" align="left" label="订单状态">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:20px;"> 
                         <el-tag :type="scope.row.status==9?'success':scope.row.status==-1?'danger':scope.row.status==-2?'danger':scope.row.status==8?'warning':scope.row.status==5?'primary':'info'">{{formatStatus(scope.row.status) }}</el-tag>
                          

                         <span v-if="scope.row.message!=null && scope.row.parmessageam!=''">
                            <el-popover placement="bottom" title="详细信息"  width="400" trigger="hover" :content="scope.row.message">
                                <span style="background:none;color:#666;border:none;" slot="reference" >{{scope.row.message.length>40?scope.row.message.substr(0,37)+'...':scope.row.message}}</span>
                            </el-popover> 
                        </span>
                        </p>
                   </template>
                </el-table-column>          
                <!--<el-table-column prop="goodsName" min-width="150" align="left" label="备注">
                    <template slot-scope="scope" >
                        <el-input type="textarea" rows="2" @change="setReamrks(scope.$index, scope.row)" v-model.trim="scope.row.remarks" placeholder="备注" style="width:100%"></el-input>  
                   </template>
                </el-table-column>  -->

                <el-table-column prop="createTime" min-width="210" align="left"  label="订单时间">
                    <template slot-scope="scope" >
                        <p style="font-size:12px;line-height:18px;">
                        订单创建：{{scope.row.createTime}}<br>
                        最后操作：{{scope.row.endTime}}<br>
                        订购时间：{{scope.row.backTime}}<br> 
                        </p>
                   </template>   
                </el-table-column>   
                <el-table-column label="操作" min-width="110" align="center"  fixed="right">
                    <template slot-scope="scope">     
                        <span class='tableOperBtn' @click="handleDetail(scope.row)"><i class='el-icon-lx-attention'></i> 用户信息</span> 
                        <!-- <el-dropdown style=" ">
                            <span class='tableOperBtn'>
                                <i class='el-icon-lx-attention'></i> 查看<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <span class='tableOperBtn2' @click="handleDetail(scope.row)">用户信息</span><br>
                                <span class='tableOperBtn2' @click="handleStep(scope.row)">订单轨迹</span> 
                            </el-dropdown-menu>
                        </el-dropdown> 
                        <el-dropdown style="margin: 0px;">
                            <span class='tableOperBtn'>
                               <i class='el-icon-edit'></i> 操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <span class='tableOperBtn2' @click="setStatus(scope.row)">状态变更</span><br>
                                <span class='tableOperBtn2' @click="handleDeduc(scope.row)">扣量计算</span><br>
                                <span class='tableOperBtn2' @click="handlePush(scope.row)">订单推送</span> 
                            </el-dropdown-menu>
                        </el-dropdown>  -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 100, 200,500,1000,2000]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
          </el-card>
        <el-dialog :close-on-click-modal="false" title="退订导入文件"
                   :visible.sync="dialogFormVisible"
                   :modal-append-to-body='false'
                   :close-on-press-escape="false"
                   :show-close="false"
                   @close="closeDialog">
            <el-form :model="formtd"   ref="formtd" :rules="formtdRules">
                <el-form-item label="上游资源" :label-width="formLabelWidth" >
                    <el-select v-model="formtd.cid"   placeholder="资源名称" filterable  clearable style='width: 320px;'>
                        <el-option value="" label="全部"  />
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item label="订单时间段" :label-width="formLabelWidth">
                    <el-date-picker v-model="formtd.startTime" :picker-options="pickerOptions1" value-format="yyyy-MM-dd HH:mm:ss" style="width:160px;" type="datetime"  placeholder="开始时间"></el-date-picker>
                    <el-date-picker v-model="formtd.endTime" :picker-options="pickerOptions2" value-format="yyyy-MM-dd HH:mm:ss" style="width:160px;margin-right:10px;" type="datetime"   placeholder="结束时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="请选择文件" :label-width="formLabelWidth">
                    <el-upload
                        class="upload-demo"
                        drag
                        ref="uploadRef"
                        :multiple="false"
                        :action="''"
                        accept=".xlsx, .cvs"
                        :auto-upload="false"
                        :show-file-list="true"
                        :before-upload="beforeUpload"
                        :http-request="customUpload"
                        >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传文件xlsx，且不超过20MB</div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div  v-if="showTablePhoneExcel" >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div>
                            <el-statistic
                                group-separator=","

                                :value="excelTotal"
                                title="已解析总条数"
                            ></el-statistic>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            <el-statistic
                                group-separator=","

                                :value="excelSuccess"
                                title="已匹配总条数"
                            ></el-statistic>
                        </div>
                    </el-col>


                </el-row>
            </div>
            <el-table
                v-if="showTablePhoneExcel"
                :data="tablePhoneExcel"
                height="250"
                border
                style="width: 100%">
                <el-table-column
                    prop="orderNo"
                    label="订单号"
                     >
                </el-table-column>
                <el-table-column
                    prop="originalPhone"
                    label="脱敏号码"
                    >
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="明文号码">
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('formtd')">取 消</el-button>
                <el-button type="primary" @click="submitForm('formtd')">开始上传</el-button>
            </div>
        </el-dialog>
        <!-- 新建自主资源弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="变更状态" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="420px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="订单状态">
                    <el-radio-group  v-model.trim="form1.status" >
                        <el-radio-button label="0">校验失败</el-radio-button> 
                        <el-radio-button label="1">校验成功</el-radio-button> 
                        <el-radio-button label="2">短信失败</el-radio-button> 
                        <el-radio-button label="3">短信成功</el-radio-button> 
                        <el-radio-button label="4">回填失败</el-radio-button> 
                        <el-radio-button label="5">回填成功</el-radio-button> 
                        <el-radio-button label="8">回调超时</el-radio-button> 
                        <el-radio-button label="-1">订购失败</el-radio-button> 
                        <el-radio-button label="-2">用户退订</el-radio-button>
                        <el-radio-button label="9">订购成功</el-radio-button>
                    </el-radio-group>   
                </el-form-item>  
                <el-form-item label="状态描述">
                    <el-input v-model.trim="form1.message"  placeholder="状态描述" ></el-input>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主资源弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="批量备注" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="420px">
            <el-form ref="form3" :model="form3" label-width="90px"> 
                <el-form-item label="订单备注">
                    <el-input v-model.trim="form3.remarks" type="textarea"  placeholder="订单备注" ></el-input>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="用户信息" :visible.sync="detailVisible" :modal-append-to-body='false' top="50px" width="480px">
            <p class="label-span">
                <label class="label">手机号码</label> 
                <span style="margin-left:15px">{{form3.phone}}</span>
            </p> <br>
            <p class="label-span"> 
                <label class="label">验证码</label> 
                <span style="margin-left:15px">{{form3.sms}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">号码归属地</label> 
                <span style="margin-left:15px">{{form2.area}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">号码运营商</label> 
                <span style="margin-left:15px">{{form2.isp==1?"移动":form2.isp==2?"联通":form2.isp==3?"电信":form2.isp==4?"广电":""}}</span>
            </p> <br>  
            <p class="label-span">
                <label class="label">投放平台</label> 
                <span style="margin-left:15px">{{form2.platform}}</span>
            </p> <br> 
            <p class="label-span">
                <label class="label">用户触点</label> 
                <span style="margin-left:15px">{{form2.contact}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">用户IP</label> 
                <span style="margin-left:15px">{{form2.userIp}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">APP包名</label> 
                <span style="margin-left:15px">{{form2.appPackage}}</span>
            </p> <br>
            <p class="label-span">
                <label class="label">浏览器标识</label> 
                <span style="margin-left:15px;color:#999;font-size:12px">{{form2.ua}}</span>
            </p> <br>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="订单轨迹" :visible.sync="stepVisible" :modal-append-to-body='false' top="50px" width="1050px">
           <div style="margin-top:-10px;height:35px;color:#666;font-size:16px;margin-left:15px;height:500px;overflow-y:scroll">
                    当前订单号: <span style="color:#333;font-weight:700;margin-right:30px">{{form5.orderNo}} 
                    </span>
                    当前订单状态: 
                        <el-tag style="font-size:16px;" :type="form.status==9?'success':form5.status==-1?'danger':form5.status==8?'warning':'info'">{{form5.status==0?"校验失败":form5.status==1?"校验成功":form5.status==2?"短信失败":form5.status==3?"短信成功":
                                form5.status==4?"回填失败":form5.status==5?"回填成功":form5.status==-1?"订购失败":form5.status==9?"订购成功":form5.status==8?"回调超时":"其它"}}</el-tag>
                 
              
                    <!-- 表格主体 -->
                    <el-table
                        :data="form7"
                        border class="table"
                        style="width: 100%;margin-top:5px !important"
                        empty-text="暂无数据" >
                        <el-table-column prop="step" width="60" align="center" label="序号">
                                <template slot-scope="scope">
                                    {{scope.$index+1}}
                                </template>
                            </el-table-column>
                        <el-table-column   label="执行步骤"  width="100" align="left" >
                            <template slot-scope="scope">
                                {{
                                    scope.row.downstreamRequestUrl.includes('/sendSms')||  scope.row.downstreamRequestUrl.includes('/sendTemplate') ? '发送验证码' :
                                        scope.row.downstreamRequestUrl.includes('checkUserInfo') ? '用户校验' :
                                            scope.row.downstreamRequestUrl.includes('/callback/')||scope.row.downstreamRequestUrl.includes('/callbackPJ/') ? '上游回调' :
                                                scope.row.downstreamRequestUrl.includes('submit') ? '提交验证码' :
                                                scope.row.downstreamRequestUrl.includes('getResult')  ? '主动查询' :
                                                scope.row.downstreamRequestUrl.includes('changePush')  ? '推送下游' :
                                                    '未知操作'
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="upstreamRequestParams" label="请求上游参数"  align="left" >
                            <template slot-scope="scope">
                                <p v-if="scope.row.upstreamRequestParams!=null && scope.row.upstreamRequestParams!=''" >
                                    <el-popover placement="bottom" title="请求上游参数"  width="600" trigger="hover"  >
                                        <div style="max-height: 90%; overflow-y: auto;">
                                            <json-viewer :value="parseJson(scope.row.upstreamRequestParams)" :expand-all="true" />
                                        </div>
                                        <span v-if="scope.row.downstreamRequestUrl.includes('submit')" style="background:none;color:red;border:none;font-size:12px;" slot="reference" >{{scope.row.upstreamRequestParams.length>18?scope.row.upstreamRequestParams.substr(0,15)+'...':scope.row.upstreamRequestParams}}</span>
                                        <span v-else style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.upstreamRequestParams.length>18?scope.row.upstreamRequestParams.substr(0,15)+'...':scope.row.upstreamRequestParams}}</span>
                                    </el-popover>
                                </p>
                                <p v-else>
                                    -
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="upstreamResponseParams" label="上游响应参数"  align="center"  >
                            <template slot-scope="scope">
                                <p v-if="scope.row.upstreamResponseParams!=null && scope.row.upstreamResponseParams!=''">
                                    <el-popover placement="bottom" title="上游响应参数"  width="600" trigger="hover"  >
                                        <div style="max-height: 300px; overflow-y: auto;">
                                            <json-viewer :value="parseJson(   scope.row.upstreamResponseParams)" :expand-all="true" />
                                        </div>
                                        <span style="background:none;color:blue;border:none;font-size:12px;" slot="reference" >{{scope.row.upstreamResponseParams.length>13?scope.row.upstreamResponseParams.substr(0,10)+'...':scope.row.upstreamResponseParams}}</span>
                                    </el-popover>
                                </p>
                                <p v-else>
                                    -
                                </p>
                            </template>
                        </el-table-column>
                          <el-table-column prop="totalElapsedTime" label="整体耗时" width="100" align="center" >
                        <template slot-scope="scope">
                            {{scope.row.totalElapsedTime}} ms
                            </template>

                        </el-table-column>
                        <el-table-column prop="upstreamElapsedTime" label="上游耗时" width="100" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.upstreamElapsedTime ? scope.row.upstreamElapsedTime : '0' }} ms
                            </template>
                        </el-table-column>
                       
                        <el-table-column prop="totalElapsedTime" label="系统耗时" width="100" align="center" >
                            <template slot-scope="scope">
                                {{ scope.row.totalElapsedTime - scope.row.upstreamElapsedTime  }} ms
                            </template>
                        </el-table-column>
                    </el-table>
                
            </div>
            <div style="clear:both"></div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="回调记录" :visible.sync="backVisible" :modal-append-to-body='false' top="80px" width="920px">
            <p style="margin-top:-20px;height:35px;color:#666;font-size:16px;margin-left:15px;">
                当前订单号: <span style="color:#333;font-weight:700;margin-right:30px">{{form5.orderNo}} 
                </span> 
                <el-button type="primary" class="mr10" @click="handleBackSys(form5.orderNo)">系统回调</el-button> 
                <el-button type="primary" class="mr10" @click="handlePushMem(form5.orderNo)">推送下游</el-button> 
                </p>
            <el-table :data="form6" border class="table"  ref="multipleTable" header-cell-class-name="table-header"   >   
                <el-table-column prop="step" width="100" align="left" label="执行步骤">
                    <template slot-scope="scope">
                        {{scope.row.step==1?"上游回调":scope.row.step==2?"下游推送":""}}
                    </template>
                </el-table-column>    
                <el-table-column prop="stepStatus" min-width="80" align="left" label="执行结果">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.stepStatus==1?'success':scope.row.stepStatus==0?'warning':scope.row.stepStatus==-1?'danger':''">
                            {{scope.row.stepStatus==1?"执行成功":scope.row.stepStatus==0?"执行失败":scope.row.stepStatus==-1?"执行异常":""}} 
                        </el-tag>
                    </template>
                </el-table-column>  
                <el-table-column prop="stepStatus" min-width="80" align="left" label="执行方式">
                    <template slot-scope="scope">
                        <span>{{scope.row.operType==1?'系统执行':scope.row.operType==2?'系统轮询':scope.row.operType==3?'人工操作':"-"}}
                        </span>
                    </template>
                </el-table-column>  
                <el-table-column prop="stepStatus" min-width="170" align="left" label="执行参数">
                    <template slot-scope="scope"> 
                        <p v-if="scope.row.param!=null && scope.row.param!=''">
                        <el-popover placement="bottom" title="详细信息"  width="600" trigger="hover" :content="scope.row.param">
                            <el-button style="background:none;color:blue;border:none;" slot="reference" >{{scope.row.param.length>30?scope.row.param.substr(0,27)+'...':scope.row.param}}</el-button>
                        </el-popover> 
                        </p>
                    </template>
                </el-table-column>  
                <el-table-column prop="stepStatus" min-width="170" align="left" label="执行信息">
                    <template slot-scope="scope"> 
                        <p v-if="scope.row.info!=null && scope.row.info!=''">
                         <el-popover placement="bottom" title="详细信息"  width="600" trigger="hover" :content="scope.row.info">
                            <el-button style="background:none;color:blue;border:none;" slot="reference" >{{scope.row.info.length>30?scope.row.info.substr(0,27)+'...':scope.row.info}}</el-button>
                        </el-popover> 
                        </p>
                    </template>
                </el-table-column>   
                <el-table-column prop="createTime" width="160" align="center"  label="执行时间"></el-table-column>  
            </el-table> 
        </el-dialog>
        <el-drawer title="可视化数据面板" :visible.sync="dataVisible" direction="ttb" :append-to-body='true'  width="100%" height="100%">
            <v-content1></v-content1>
        </el-drawer>

        <el-dialog :close-on-click-modal="false" title="用户订购记录" :visible.sync="drawVisible" :modal-append-to-body='false' top="80px" width="820px"  >
            <div style="float:left;width:50%;text-align:center;margin-top:-20px;">
                <el-button @click="drawImg('1')">查看落地页记录</el-button><br>
                <img :src="formImg.img2" style='width:250px'>
                <el-button v-if='formImg.img2' style="position:absolute;background:rgb(0,0,0,0.3) !important;margin-left:-150px;color:#fff !important" @click="downFile(formImg.img2,'办理落地页')">下载</el-button><br>
                
            </div>
            <div style="float:left;width:50%;text-align:center;margin-top:-20px;">
                <el-button @click="drawImg('2')">查看二确页记录</el-button><br>
                <img :src="formImg.img3" style='width:250px;'>
                <el-button v-if='formImg.img3' style="position:absolute;background:rgb(0,0,0,0.3) !important;margin-left:-150px;color:#fff !important"  @click="downFile(formImg.img3,'二确页弹窗')">下载</el-button><br>
                
            </div>
            <div style="clear:both"></div>
        </el-dialog>
    </div>

</template>

<script>
import {
    fetchData,
    saveForm,
    handDelete,
    changeForm,
    changeStatus,
    update,
    updateMore,
    changeStatusMore,
    getOrderDetail,
    getOrderStep2,
    uploadExcel,
    getOrderBack,
    downOrderExcel,
    backSys,
    pushMem,
    getChildOrder,
    successApi,
    statusApi,
    decApi,
    pushApi,
    falsePush,
    drawImgTest
} from '../../api/comOrder';
import { changePush} from '../../api/comOrderPush';  
import {changeDeduc } from '../../api/comOrderDeduc';  
import {fetchSelect as fetchSelect6} from '../channel/channel';  //资源名称
import {fetchSelect as fetchSelect3} from '../../api/member';  //渠道名称 
import {fetchSelect as fetchSelect1} from '../../api/channelType';  //资源分类
import {fetchSelect as fetchSelect2} from '../../api/goodsType';  //产品分类
import JsonViewer from 'vue-json-viewer';
import { formatStatus } from '@/utils/filters';
import vContent1 from '../../components/page/Dashboard1.vue';
import { connectSSE, closeSSEByTableStatus } from '@/components/common/sseUtil';
export default {
    data() {
        return {
            excelTotal:0,
            excelSuccess:0,
            sseConnection: null,
            reconnectCount: 0,

            tablePhoneExcel:[],
            dialogFormVisible: false,
            showTablePhoneExcel: false,
            formLabelWidth: '120px',
            jsonData: {
                key1: "value1",
                key2: 2,
                key3: true
            },
            formattedJson: "",
            Timeout:'', 
            activeNames:1,
            select1:{ option:'',  },
            select2:{ option:'',  },
            select3:{ option:'',  },
            select6:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            formImg:{
                img2:'',
                img3:'',
            },
            query: {
                isPj: "0",
                pageIndex: 1,
                pageSize: 10,
                phoneList: '',
                cid2:'46',
            },
            tableData: [], 
            multipleSelection: [],
            delList: [],
            showDiv:true,
            showDiv2:true,
            show:'v',
            show2:'● 查看接口请求数据 >',
            editVisible: false,
            dataVisible:false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            backVisible:false,
            stepVisible:false,
            drawVisible:false,
            loading:false,
            row:{},
            pageTotal: 0,
            formtd: {
                cid:'',
                startTime:'',
                endTime:'',
                file: ''
            },
            formtdRules: {
                cid: [
                    { required: true, message: '请选择上游资源', trigger: 'blur' }
                ],
                startTime: [
                    { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                ],
                endTime: [
                    { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
                ]

            },
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                smsFrom:'1', 
                smsType:'1',  
            },
            form2: {  },
            form3: {  phone:'',sms:''  },
            form4: {   },
            form5: {   },
            form6: {   },
            form7: {   },
            idx: -1,
            id: -1,
            ids:'',
            pickerOptions1: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) { 
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', [dayDate1, dayDate2]);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) { 
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', [dayDate1, dayDate2]);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                    const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
                        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
                        picker.$emit('pick', [dayDate1, dayDate2]);
                    }
                }]
            }
        };
    },
    components: { 
        vContent1 ,
        JsonViewer
    },
    created() {
        var nowDate = new Date();
        var date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth(),
            day: nowDate.getDate()
        };
        if(date.month==0){
            date.month = 12;
            date.year =  date.year - 1;
        }else{
            date.month = date.month +1;
        }
        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
        this.$set(this.query, "timeRange", [dayDate1, dayDate2]);
        // 默认当天0点
        /*var nowDate = new Date();
        var date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth(),
            day: nowDate.getDate()
        };
        if(date.month==0){
            date.month = 12;
            date.year =  date.year - 1;
        }else{
            date.month = date.month +1;
        }
        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 00:00:00";
        const dayDate2 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day)+" 23:59:59";
    
        this.$set(this.query, "startTime", dayDate1.toString());  
        this.$set(this.query, "endTime", dayDate2.toString());   */
    },
    //页面加载方法
    mounted: function () {  
        //查询列表
        this.getSelect1();
        this.getSelect2(); 
        //this.getSelect3(); 
        //this.getSelect6(); 
        this.handleSearch();
    },
    beforeDestroy() {
        // 离开前保存 query 到本地
        localStorage.setItem('comOrderQuery', JSON.stringify(this.query));
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    methods: {

        formatUrlParams(url) {
            try {
                const urlObj = new URL(url);
                const params = new URLSearchParams(urlObj.search);
                const decodedParams = {};

                for (const [key, value] of params.entries()) {
                    decodedParams[key] = decodeURIComponent(value.replace(/\+/g, ' '));
                }

                // 返回对象，包含原始 URL 和解析后的参数
                return {
                    url: urlObj.toString(),
                    params: decodedParams
                };
            } catch (e) {
                return { error: '无效的 URL' };
            }
        },
        parseJson(jsonStr) {
            try {
                return JSON.parse(jsonStr);
            } catch (e) {
                return { error: '无效的 JSON 格式', raw: jsonStr };
            }
        },
        formatDateTime(time) {
            if (!time) return '-';
            const date = new Date(time);
            return (
                [
                    date.getFullYear(),
                    this.padZero(date.getMonth() + 1),
                    this.padZero(date.getDate())
                ].join('-') +
                ' ' +
                [
                    this.padZero(date.getHours()),
                    this.padZero(date.getMinutes()),
                    this.padZero(date.getSeconds())
                ].join(':') +
                '.' +
                this.padZero(date.getMilliseconds(), 3) // 添加三位毫秒值
            );
        },
        drawer_open(row){
            this.formImg.orderNo = row.orderNo;
            this.formImg.goodsCode = row.goodsCode; 
            this.drawVisible = true;
        },
        drawImg(index){
            this.formImg.index = index;
            drawImgTest(this.formImg).then(res => {   
                if(res.code=='200'){ 
                    if(index==1){
                        this.formImg.img2 = res.data;
                    }else if(index==2){
                        this.formImg.img3 = res.data;
                    }
                }else{
                    this.$message(res.message);   
                } 
            }); 
        },
        downFile(url,name) {
            let fileUrl = url  //服务器文件地址
            this.getBlob(fileUrl).then(blob => {
                this.saveAs(blob, name)
            })
        },
        //通过文件下载url拿到对应的blob对象
        getBlob(url) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response)
                }
            }
        
            xhr.send()
            })
        },
        //下载文件
        saveAs(blob, filename) {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
        },
        padZero(num, size = 2) {
            let s = num + '';
            while (s.length < size) s = '0' + s;
            return s;
        },
        handleBeforeUnload(event) {
            // 在这里执行页面关闭前的操作
            localStorage.removeItem('comOrderQuery');
        },
        formatStatus,
        load(tree, treeNode, resolve) {  
            let data = {};
            data.pid = tree.id; 
            getChildOrder(data).then(res => {   
                if(res.code=='200'){ 
                    if(res.data==null || res.data.length==0){
                        this.$message("暂无子订单");  
                        resolve([]);
                    }else{
                        resolve(res.data);  
                    }
                    
                }else{
                    this.$message(res.message);  
                    resolve([]);
                } 
            }); 
        }, 
        // 触发搜索按钮 
        handleSearch() {
            if(this.query.timeRange!=null && this.query.timeRange!=undefined && this.query.timeRange!=''){
                this.query.startTime = this.query.timeRange[0];
                this.query.endTime = this.query.timeRange[1];
            }else{
                this.$message({
                    message: '订单时间段不能个为空',
                    type: 'warning'
                });
                return;
            }
            if(this.query.timeRange2!=null && this.query.timeRange2!=undefined && this.query.timeRange2!=''){
                this.query.startTime2 = this.query.timeRange2[0];
                this.query.endTime2 = this.query.timeRange2[1];
            }
            if(this.query.status2!=undefined){
                this.query.status = this.query.status2.filter(tag => tag !== '').join();
                if(this.query.status.charAt(0) === ','){
                    this.query.status = this.query.status.substring(1);
                }
            } 
            if(this.query.phone!=null && this.query.phone!=undefined && this.query.phone!=''){
                if(this.query.phone.length!=11){
                    this.$message({
                        message: '用户号码必须为11位',
                        type: 'warning'
                    });
                    return;
                }
            }
             
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'startTime');  
            this.$set(this.query, 'endTime');  
            this.$set(this.query, 'startTime2');  
            this.$set(this.query, 'endTime2');
            this.$set(this.query, 'timeRange2'); 
            this.$set(this.query, 'loginName');  
            this.$set(this.query, 'phone');  
            this.$set(this.query, 'orderTno');  
            this.$set(this.query, 'orderOno');  
            this.$set(this.query, 'status');    
            this.$set(this.query, 'status2');    
            this.$set(this.query, 'goodsName');    
            this.$set(this.query, 'ctype');    
            this.$set(this.query, 'orderNo');    
            this.$set(this.query, 'goodsCode');    
            this.$set(this.query, 'channelGoodsCode');    
            this.$set(this.query, 'goodsRate');    
            this.$set(this.query, 'goodsIsp');    
            this.$set(this.query, 'goodsComType');    
            this.$set(this.query, 'memPhone');    
            this.$set(this.query, 'message');    
            this.$set(this.query, 'isDeduction');    
            this.$set(this.query, 'isPush');    
            this.$set(this.query, 'isBack');    
            this.$set(this.query, 'isPj');    
            this.$set(this.query, 'mids');    
            this.$set(this.query, 'phoneList');
            this.handleSearch();
        }, 

        dataPan(){ 
            this.$router.push('/dataShow'); 
            
            //this.dataVisible = true;
        },
         
        getMore(data){
             this.$notify({  message: data,duration: 3000 });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        showMore(){
            if(this.showDiv){
                this.show = '>';
                this.showDiv = false;
            }else{
                this.show = 'v';
                this.showDiv = true;
            } 
        },
        showMore2(){
            if(this.showDiv2){
                this.show2 = '● 收起接口请求数据 V';
                this.showDiv2 = false;
            }else{
                this.show2 = '● 查看接口请求数据 >';
                this.showDiv2 = true;
            }
        },
        handleBackSys(orderNo){
            let data = {};
            data.orderNo = orderNo; 
            backSys(data).then(res => {   
                if(res.code=='200'){ 
                    this.handleBack(this.form5); 
                    this.$notify({ title: '成功', message: '回调成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '回调失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        batchSuccessApi(){
            let data = {};
            this.$notify({ title: '', message: '订单折算中...',duration: 1000, type: 'info' });
            successApi(data).then(res =>{
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '订单折算成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '订单折算失败',duration: 1000, type: 'error' });
                }
            });
        },
        batchStatusApi(){
            let data = {};
            this.$notify({ title: '成功', message: '状态正在更新...',duration: 1000, type: 'success' });
            statusApi(data).then(res =>{
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '状态更新成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '状态更新失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        batchDecApi(){
            let data = {};
            this.$notify({ title: '成功', message: '正在进行扣量计算...',duration: 1000, type: 'success' });
            decApi(data).then(res =>{
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '扣量计算成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '扣量计算失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        batchPushApi(){
            let data = {};
            this.$notify({ title: '成功', message: '正在进行下游推送（不包含推送天猫、流量果）...',duration: 1000, type: 'success' });
            pushApi(data).then(res =>{
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '下游推送成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '下游推送失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        handlePushMem(orderNo){
            let data = {};
            data.orderNo = orderNo;
            pushMem(data).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '推送成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '推送失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        batchFalsePush(){
             const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要关闭推送的订单");
                return;
            }
            var that = this;
            that.$confirm('确认关闭推送吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                this.loading = true;  
                setTimeout(() => {
                    if(this.loading){
                        this.loading = false;   
                        this.$message("等待后台执行..."); 
                    } 
                }, 5000);   
                for (let i = 0; i < length; i++) { 
                    setTimeout(() => {
                        that.falsePush2(that.multipleSelection[i]);
                        if(i==length-1){
                            setTimeout(() => {
                                this.loading = false;  
                                this.getData();
                            }, 1500); 
                        }
                    }, 350*i);  
                    
                }   
            });
        },

        batchPush(){
            const length = this.multipleSelection.length;
            if(length===0){
                this.$message.error("请勾选要执行推送的订单");
                return;
            }
            var that = this;
            that.$confirm('确认执行批量推送吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                this.loading = true;  
                setTimeout(() => {
                    if(this.loading){
                        this.loading = false;  
                        this.getData();
                        this.$message("等待后台执行..."); 
                    } 
                }, 5000);   
                for (let i = 0; i < length; i++) { 
                    setTimeout(() => {
                        that.handlePush2(that.multipleSelection[i]);
                        if(i==length-1){
                            setTimeout(() => {
                                this.loading = false;  
                                this.getData();
                            }, 1500); 
                        }
                    }, 350*i);  
                    
                }   
            });
        },
        handlePush2(row){   
            changePush(row).then(res => {
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                }
            });  
        },
        falsePush2(row){   
            falsePush(row).then(res => {
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.orderNo+'关闭推送成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message:  row.orderNo+'关闭推送失败：'+res.message,duration: 5000, type: 'error' });
                }
            });  
        },

        handlePush(row){
            if(row.isDeduction==0){
                this.$message.error("请先进行扣量计算后再执行推送！");
                return;
            }
            var that = this;  
            that.$confirm('确认执行推送吗？', '提示', {
                type: 'warning'
            }).then(res => {  
                that.loading = true;  
                changePush(row).then(res => {
                    that.loading = false;  
                    if(res.code=='200'){ 
                        that.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                        setTimeout(() => {
                            that.getData();
                        }, 1000);   
                    }else{
                        that.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                    }
                });  
            });        
        },
        handleDeduc(row){ 
            var that = this;
            that.$confirm('确认执行扣量吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                that.loading = true;  
                changeDeduc(row).then(res => {
                    that.loading = false;  
                    if(res.code=='200'){ 
                        that.$notify({ title: '成功', message: row.orderNo+'推送执行成功',duration: 1000, type: 'success' });
                        setTimeout(() => {
                            that.getData();
                        }, 1000);   
                    }else{
                        that.$notify({ title: '失败', message:  row.orderNo+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                    }
                }); 
            });
        },
 

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 
        setReamrks(index,row){ 
            let data = {};
            data.remarks = row.remarks;
            data.id = row.id;
            update(data).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '设置失败'+res.message,duration: 1000, type: 'danger' });
                }
            });
        },
        setReamrksMore(){
            
        },
        downExcel(){
            var that = this;
            that.$confirm('确认要导出吗？', '提示', {
                type: 'warning'
            }).then(() => {
                setTimeout(() => {
                    if(that.loading){ return; }
                    that.loading = false;
                    that.getData();
                }, 7000)
                if(that.query.timeRange!=null && that.query.timeRange!=undefined && that.query.timeRange!=''){
                    that.query.startTime = that.query.timeRange[0];
                    that.query.endTime = that.query.timeRange[1];
                }
                if(that.query.timeRange2!=null && that.query.timeRange2!=undefined && that.query.timeRange2!=''){
                    that.query.startTime2 = that.query.timeRange2[0];
                    that.query.endTime2 = that.query.timeRange2[1];
                }
                if(that.query.status2!=undefined){
                    that.query.status = that.query.status2.filter(tag => tag !== '').join();
                    if(that.query.status.charAt(0) === ','){
                        that.query.status = that.query.status.substring(1);
                    }
                }
                if(that.query.phone!=null && that.query.phone!=undefined && that.query.phone!=''){
                    if(that.query.phone.length!=11){
                        that.$message({
                            message: '用户号码必须为11位',
                            type: 'warning'
                        });
                        return;
                    }
                }
                that.loading = true
                downOrderExcel(that.query).then(res => {
                    that.loading = false
                    if (res.code == '200') {
                        that.$notify({ title: '成功', message: res.message, duration: 5000, type: 'success' });
                    } else {
                        that.$notify({ title: '失败', message: '后台下载异常', duration: 5000, type: 'error' });
                    }
                });
            });
        },
        //获取下拉框数据
        getSelect1(){ 
            this.select1 = {};  
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {}; 
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        },
        getSelect3(){ 
            this.select3 = {}; 
            fetchSelect3(this.select3).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select3, 'option', res.data);  
                }
            });
        },
        getSelect6(){ 
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },
        //查询
        getData(){
            this.loading = true; 
            fetchData(this.query).then(res => {
                this.loading = false;
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
          
        copyLink(text,name){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },
        

        handleRemarksMore(){
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要备注的订单");
                return;
            }
            this.ids = '';
            for (let i = 0; i < length; i++) { 
                this.ids += this.multipleSelection[i].id + ',';  
            }  
            this.ids = this.ids.substr(0,this.ids.length-1);  
            this.form3.id = this.ids;
            this.editVisible = true;
        }, 
       
        // 保存更改
        saveEdit() {    
            if( !this.form3.remarks ){
                this.$message.error("请填写订单备注");
                return;
            }    
            updateMore(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },

        // 修改状态
        setStatus(row) {
            this.form1 = row;
            this.addVisible = true; 
        },
        
         handleStatusMore(){
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要变更状态的订单");
                return;
            }
            this.ids = '';
            for (let i = 0; i < length; i++) { 
                this.ids += this.multipleSelection[i].id + ',';  
            }  
            this.ids = this.ids.substr(0,this.ids.length-1);  
            this.form1.id = this.ids;
            this.addVisible = true;
        },
        getDetail(row){

        },
        //保存新增
        saveForm() {   
            if( !this.form1.status ){
                this.$message.error("请选择订单变更状态");
                return;
            }  
            if( !this.form1.message ){
                this.$message.error("请填写状态描述");
                return;
            }    
            this.addVisible = false;
            if(this.form1.status==5){
                this.form1.isBack = 0;
            }
            this.form1.param = localStorage.getItem(window.location.hostname+'_loginName')+"-"+localStorage.getItem(window.location.hostname+'_phone');  
            changeStatusMore(this.form1).then(res => {
                if(res.code=='200'){
                   
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                     this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        }, 

        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail( row){    
            getOrderDetail(row).then(res => {
                if(res.code=='200'){
                    if(res.data==null){
                        this.$message.error("暂无数据"); 
                        return;
                    }
                    this.detailVisible = true;  
                    this.form2 = res.data;
                    this.form3.phone = row.phone; 
                    this.form3.sms = row.sms;
                }else{
                    this.$message.error(res.message); 
                } 
            }); 
        },
        handleStep( row){
            getOrderStep2(row).then(res => {
                if(res.code=='200'){
                    this.stepVisible = true;
                    //apiCallLogList
                    // comOrderStepList 
                    this.form7 = res.data.apiCallLogList;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message); 
                } 
            }); 
        },
        handleBack( row){
            getOrderBack(row).then(res => {
                if(res.code=='200'){
                    this.backVisible = true;  
                    this.form6 = res.data;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message); 
                } 
            }); 
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id;  
            // 二次确认删除
            this.$confirm('该资源所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该资源商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        beforeUpload(file) {

            const isValidSize = file.size / 1024 / 1024 < 20;
            const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
            if (!isExcel) {
                this.$message.error('只能上传 Excel 文件 (.xlsx, .xls)');
                return false; // 阻止上传
            }
            return true;
            if (!isValidSize) {
                this.$message.error('文件大小不能超过 20MB');
            }

            return isValidType && isValidSize;
        },
        customUpload(fileObj) {
            const formData = new FormData();
            // 添加文件
            formData.append('file', fileObj.file);
            // 添加其他字段
            formData.append('cid', this.formtd.cid); // 上游资源名称
            formData.append('startTime', this.formtd.startTime); // 开始时间
            formData.append('endTime', this.formtd.endTime); // 结束时间

            // 发送请求
            uploadExcel(formData).then(res => {
                if (res.code === '200') {
                    this.$message.success(res.message);

                    this.sseConnection = connectSSE(this,"excel_upload");
                    this.sseConnection.addEventListener('message', (event) => {
                        try {
                            console.log("sse接受到消息====>",event.data);
                            const data = JSON.parse(event.data);
                            if (data.id) {
                                console.log('收到SSE消息===>开始更新进度');
                                console.log('当前tablePhoneExcel:', this.tablePhoneExcel);
                                console.log('要更新的id:', data.id);
                                console.log('要更新的进度:', data.process);
                                console.log('要更新的list:', data.list);
                                if (data.total){
                                    this.excelTotal = data.total;
                                }
                                if (data.list){
                                    if (!this.showTablePhoneExcel){
                                        this.showTablePhoneExcel = true;
                                    }
                                    this.excelSuccess += data.list.length ;
                                    data.list.forEach(item => {
                                        this.tablePhoneExcel.unshift(item);
                                    });
                                }

                                if (data.process == 100) {
                                    this.closeSSE();
                                }
                            }
                        } catch (error) {
                            console.error('SSE message parsing error:', error);
                        }
                    });
                    // this.resetFormtd();
                } else {
                    this.$message.error('上传失败: ' + res.message);
                }
            }).catch(err => {
                this.$message.error('上传过程中发生错误: ' + err);
            });
        },
        resetFormtd() {
            this.formtd = {
                cid: '',
                startTime: '',
                endTime: '',
                file: ''
            };
        },
        resetForm(formName) {
            this.$refs[formName].resetFields(); // 重置表单验证
            this.resetFormtd(); // 重置 formtd 数据
            this.$refs.uploadRef.clearFiles(); // 关键代码，清空文件列表
            this.dialogFormVisible =false;
        },
        closeDialog(){
            this.closeSSE();
            this.showTablePhoneExcel =false;
            this.excelTotal = 0;
            this.excelSuccess = 0;
            this.tablePhoneExcel = 0;
        },
        closeSSE(){

            console.log("检测到弹窗关闭,关闭定时任务")
            if ( this.sseConnection){
                this.sseConnection.close();
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 手动触发上传
                    this.$refs.uploadRef.submit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};
</script>
<style>
.el-drawer__open .el-drawer.ttb {
    height:100% !important;
}
</style>
<style scoped> 

 :v-deep .el-icon-arrow-right:before { 
        color: #1890ff;

        font-size: 20px;

        font-weight: 700px; 
    }

    ::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
         
        font-size:15px;
        color:#409EFF; 
        text-align: center;
    } 
    ::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before{ 
        font-size:15px;
        color:#999; 
        text-align: center;
    }
    

.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 145px;
    display: inline-block;
}

.handle-input {
    width: 145px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table__row--level-1{
        background-color: #efefef !important;
    }
    .el-table__row--level-1:hover{
         background-color: #efefef !important;
    }
     .el-table__row--level-1::after{
         background-color: #efefef !important;
    }
.el-table--small .el-table__cell{
    padding:3px 2px;
}
.el-table .cell{
    padding:3px 2px;
}
.white-space-pre-line {
    white-space: pre-line; /* 保留换行符，自动合并空格 */
}
</style>
